import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';
import Tag from 'antd/lib/tag';

export const StyledTag: StyledComponent<typeof Tag, any> = styled(Tag)`
  &.ant-tag-small {
    line-height: 14px;
    font-size: 11px;
    padding: 0 5px;
  }
`;
